import $ from '../core/Dom';
import Viewport from '../core/Viewport';
import Dispatch from '../core/Dispatch';
import EcoMode from '../lib/EcoMode';

import { USER_PREFERENCES_UPDATED } from '../lib/events';
import { loadFlickity } from '../lib/async-bundles';

export default (el, props) => {
    const $el = $(el);

    const $slideWrapper = $el.find('[data-slide-wrapper]');
    const $slides = $el.find('[data-slide-item]');
    const $navButtons = $el.find('[data-slide-nav-button]');

    let Flickity = null;
    let slideshow = null;
    let lastW = 0;

    const init = () => {
        if (EcoMode.shouldAnimate()) {
            loadBundles();
        }

        $navButtons.on('click', e => {
            e.preventDefault();
            const $target = $(e.triggerTarget);
            const newSlideIndex = $target.data('slide-nav-button');

            showSlide(newSlideIndex);
        });

        Viewport.on('resize', onResize);
        Dispatch.on(USER_PREFERENCES_UPDATED, onUserPreferencesUpdated);
    };

    const destroy = () => {
        destroyFlickity();
        $navButtons.off('click');
        Viewport.off('resize', onResize);
        Dispatch.off(USER_PREFERENCES_UPDATED, onUserPreferencesUpdated);
    };

    const onUserPreferencesUpdated = () => {
        if (EcoMode.shouldAnimate()) {
            if (Flickity === null) {
                loadBundles();
            }
        } else {
            if (slideshow !== null) {
                destroyFlickity();
            }
            
            Flickity = null;
        }
    };

    const onResize = () => {
        if (lastW !== Viewport.width) {
            if (Flickity) {
                initFlickity();
            }

            lastW = Viewport.width;
        }
    };

    const loadBundles = () => {
        if (Flickity === null) {
            loadFlickity(flickity => {
                Flickity = flickity;
                // gsap.defaults({ overwrite: 'auto' });
    
                initFlickity();
            });
        }
    };

    const showSlide = num => {
        if (slideshow) {
            slideshow.selectCell(num);
        } else {
            $slides.css({ display: 'none' });
            $slides.eq(parseInt(num, 10)).css({ display: 'block' });

        }

        setButtons(num);
    };

    const setButtons = activeNum => {
        $navButtons.removeClass('selected');
        $navButtons.eq(parseInt(activeNum, 10)).addClass('selected');
    };

    const initFlickity = () => {
        destroyFlickity();

        $el.addClass('js-has-flickity');

        $slides.css({ display: 'block' });

        $slides.each(item => {
            const $item = $(item);

            $item.css({
                height: $item.height()
            });
        });

        $slideWrapper.css({
            height: `${$slideWrapper.height()}px`
        });

        slideshow = new Flickity($slideWrapper.get(0), {
            pageDots: false,
            prevNextButtons: false,
            setGallerySize: false,
            resize: false,
            wrapAround: true,
            freeScroll: false,
            groupCells: false,
            cellAlign: 'left',
            contain: true,
            autoPlay: 7000,
            accessibility: false
        });

        slideshow.on('dragStart', () => slideshow.slider.childNodes.forEach(slide => {
            slide.style.pointerEvents = 'none';
        }));

        slideshow.on('dragEnd', () => slideshow.slider.childNodes.forEach(slide => {
            slide.style.pointerEvents = 'all';
        }));

        slideshow.on('select', index => {
            setButtons(index);
        });
        
        setButtons(0);
    };


    const destroyFlickity = () => {
        if (!slideshow) {
            return;
        }

        slideshow.destroy();
        slideshow = null;

        $slideWrapper.attr('style', '');
        $slides.attr('style', '');

        $el.removeClass('js-has-flickity');
        
        showSlide(0);
    };

    return {
        init,
        destroy
    };

};
